import { render, staticRenderFns } from "./SyncQuestion.vue?vue&type=template&id=324ab865&"
import script from "./SyncQuestion.vue?vue&type=script&lang=js&"
export * from "./SyncQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SyncQuestion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports